import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Autocomplete from "@mui/material/Autocomplete/Autocomplete";
import Checkbox from "@mui/material/Checkbox/Checkbox";
import TextField from "@mui/material/TextField/TextField";
import { ChipsSkill } from "../components/Chips";
import { getAllExperienceReference } from "../../../services/api/Curriculum/Experiences/experiencesService";
import { IExperiencesDto } from "../../../@types/curriculum.type";

interface ExperiencesProps {
  setValue: React.Dispatch<React.SetStateAction<IExperiencesDto[]>>;
  experiencesValue: IExperiencesDto[];
  isEdit: boolean;
}

export const Experiences: React.FC<ExperiencesProps> = ({
  setValue,
  experiencesValue,
  isEdit,
}) => {
  const [selectedSkills, setSelectedSkills] = useState<IExperiencesDto[]>();
  const [optionsSkills, setOptionsSkills] = useState<IExperiencesDto[]>([]);

  useEffect(() => {
    if (selectedSkills) setValue(selectedSkills);
  }, [selectedSkills]);

  useEffect(() => {
    loadInfo();
  }, []);

  const loadInfo = async () => {
    const response = (await getAllExperienceReference()) as IExperiencesDto[];
    setOptionsSkills(response);
    setSelectedSkills(experiencesValue);
  };

  return (
    <>
      <div className={styles.experiences}>
        <div className={styles.divSkills}>
          {isEdit && (
            <Autocomplete
              options={optionsSkills}
              isOptionEqualToValue={(option, value) =>
                option.description == value.description
              }
              getOptionLabel={(option) => option.description || ""}
              value={selectedSkills || []}
              onChange={(_, newValue) => setSelectedSkills(newValue)}
              multiple
              noOptionsText="Sem opções"
              disableCloseOnSelect
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={option.id} {...optionProps}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />
                    {option.description}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Selecione suas Experiências"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  fullWidth
                />
              )}
            />
          )}
          <div className={styles.skills}>
            {selectedSkills && selectedSkills.length > 0 && (
              <ChipsSkill skills={selectedSkills} type="experiences" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};
